import {inject, Pipe, PipeTransform} from '@angular/core';
import {GRID_SUMMARIES_TOKEN} from "../shared/summaries/grid-summaries-custom-neo-config";

@Pipe({
  name: 'summaryPipeNeo',
  standalone: true
})
export class SummaryPipeNeoPipe implements PipeTransform {

  private summaries = inject(GRID_SUMMARIES_TOKEN);

  transform(summaryName: keyof typeof this.summaries) {
    return this.summaries[summaryName];
  }

}
